import React from 'react';

export const AdultsOnlyErectionIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18.9199 51.8201C12.0799 47.4401 10.0599 38.3201 14.4199 31.4601C18.7799 24.6001 27.9199 22.6001 34.7799 26.9601C41.6399 31.3201 43.6399 40.4601 39.2799 47.3201C34.8999 54.1601 25.7799 56.1801 18.9199 51.8201ZM30.4799 33.7201C27.3399 31.7201 23.1799 32.6401 21.1799 35.7801C19.1799 38.9201 20.0999 43.0802 23.2399 45.0802C26.3799 47.0802 30.5399 46.1601 32.5399 43.0201C34.5399 39.8801 33.6199 35.7201 30.4799 33.7201Z"
        fill="#007FB5"
      />
      <path d="M40.3108 10.8685L29.2457 28.197L35.9884 32.5025L47.0534 15.1739L40.3108 10.8685Z" fill="#007FB5" />
      <path d="M43.9 28.12L40.84 17.5L29.92 19.2L28.7 11.28L46.56 8.54004L51.58 25.92L43.9 28.12Z" fill="#007FB5" />
      <path
        d="M19.22 53.16C12.38 48.78 10.36 39.66 14.72 32.8C19.08 25.94 28.22 23.94 35.08 28.3C41.94 32.66 43.94 41.8 39.58 48.66C35.22 55.52 26.08 57.52 19.22 53.16ZM30.78 35.06C27.64 33.06 23.48 33.98 21.48 37.12C19.48 40.26 20.4 44.42 23.54 46.42C26.68 48.42 30.84 47.5 32.84 44.36C34.84 41.22 33.92 37.06 30.78 35.06Z"
        fill="#00A6ED"
      />
      <path d="M40.6216 12.1968L29.5565 29.5254L36.2991 33.8309L47.3642 16.5023L40.6216 12.1968Z" fill="#00A6ED" />
      <path
        d="M44.2 29.4601L41.12 18.8401L30.2 20.5201L28.98 12.6201L46.86 9.86011L51.88 27.2401L44.2 29.4601Z"
        fill="#00A6ED"
      />
    </svg>
  );
};
